export default __webpack_public_path__ + "assets/fonts/cormorant-garamond-v14-latin-regular.svg";